export default "__VITE_ASSET__be4f43e3__"